module.exports = __webpack_public_path__ + "img/tutorial2.29064394.png";